
<template>
	<div class="mb-16">
		<SearchFilterComponent
			class="mb-8"
			store-key="database"
			input-placeholder="Search for an asset, project or tag"
		/>
	</div>

	<Transition name="fade">
		<div
			v-show="show_filters"
			class="filters mb-16"
		>
			<div
				v-if="loading"
				class="flex flex--justify-center"
			>
				<PageLoaderComponent :small="true" />
			</div>
			<div
				v-else
				class="filters__row"
			>
				<div class="filters__column filters__column--space-between">
					<div>
						<button
							class="edit-filters mb-16"
							@click="show_filter_modal = true"
						>
							Edit filters
						</button>
						<div
							v-if="selected_dropdown_filter_components.length"
							class="grid grid--stretch grid--xs flex flex--wrap full-width mb-16"
						>
							<div
								v-for="filter in selected_dropdown_filter_components"
								:key="'dropdown-filter-component-' + filter.value"
								class="grid__item a4-12 c6-12 mb-8"
							>
								<DropdownFilterComponent
									store-key="database"
									:label="filter.label"
									:filter-key="filter.value"
									:filter-options-key="filter.options_key ?? null"
									:get-options-method="filter.get_options_method ?? null"
									:search-disabled="filter.search_disabled ?? false"
								/>
							</div>
						</div>
						<p v-else>
							No filters selected
						</p>
					</div>

					<Teleport to="#modal">
						<Transition name="fade">
							<FilterModalComponent
								v-if="show_filter_modal"
								store-key="database"
								@close-modal="show_filter_modal = false"
							/>
						</Transition>
					</Teleport>

					<DatabaseActiveDropdownFiltersComponent />
				</div>
				<div class="filters__column">
					<TagsFilterComponent
						store-key="database"
					/>
				</div>
			</div>
		</div>
	</Transition>
</template>

<script setup>
import DropdownFilterComponent from './filters/DropdownFilterComponent';
import DatabaseActiveDropdownFiltersComponent from './filters/DatabaseActiveDropdownFiltersComponent';
import FilterModalComponent from './modals/FilterModalComponent';
import TagsFilterComponent from './filters/TagsFilterComponent';
import SearchFilterComponent from './filters/SearchFilterComponent';
import PageLoaderComponent from './PageLoaderComponent';

import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useDatabaseFiltersStore } from '../stores/database-filters';

const filters_store = useDatabaseFiltersStore();

const {
	getBoundaryStaffUsers,
	getCompanies,
	getMediaTypes,
	getProjectTypes,
	getProjectLocations,
	getDefaultFilters,
	getCommonOptions,
	getProjectStatusOptions
} = filters_store;

const {
	show_filters,
	selected_dropdown_filter_components
} = storeToRefs( filters_store );

const show_filter_modal = ref( false );

const loading = ref( true );

onMounted ( async() => {
	await getDefaultFilters();
	await getBoundaryStaffUsers();
	await getCompanies();
	await getMediaTypes();
	await getProjectTypes();
	await getProjectLocations();
	await getCommonOptions();
	await getProjectStatusOptions();
	loading.value = false;
} );
</script>